import $ from 'jquery';

const accordion = () => {

    $(document).on("click", ".accordion-heading", function () {
    const $heading = $(this);
    const $content = $heading.siblings(".accordion-content");

    $heading.toggleClass("is-active");

    $content.stop(true, true).slideToggle(300);
    });

  };

export default accordion;
